import requestByUser from './api'
import {OrderInternalResponseDTO} from "./DTO/Order";

export const getOrderDetail = async (vendorUuid : string, orderCode : string) => {
    return (await requestByUser<OrderInternalResponseDTO>('get', `/api/manager/appstore/vendors/${vendorUuid}/orders/${orderCode}`)).data;
}